export const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};
